<span *ngIf="errorMessage !== null" class="general-error">
	<span class="di di-alert error-message"></span>{{ errorMessage | translate }}
</span>
<awakening-calendar [dates]="availableDates"
                    [availabilityTypes]="availabilityTypes"
                    [selectedDate]="selectedDate.raw"
                    [endDate]="calendarEndDate"
                    (selected-date-changed)="getParksAvailability($event)"
                    (wdat-calendar.navigation-change)="getAvailabilityForSelectedSegment($event)"></awakening-calendar>
<awakening-availability-information title="{{reservationsTitle | translate: [selectedDate.formatted]}}"
                                    [availableParks]="selectedDate.availability"
                                    [calendarHasContent]="calendarHasContent"
                                    disclaimer="{{reservationsDisclaimer | translate}}"></awakening-availability-information>